module.exports = __webpack_public_path__ + "img/LogoIEPTB_BR.7dc8bdfd.png";